import React, { Component } from 'react';
import SubTitle from 'components/FacilityRequestComponents/ResourceComponents/SubTitle';
import AfterHoursSpacesDropDown from 'components/FacilityRequestComponents/AH/Reusable/AfterHoursSpacesDropDown';
import TemperatureWidget from 'components/FacilityRequestComponents/Comfort/TemperatureWidget';
import styles from 'components/FacilityRequestComponents/Maintenance/maintenance.module.css';
import ComfortStyles from 'components/FacilityRequestComponents/Comfort/Modules/Comfort.module.css';
import { setAmplitudeEvent} from 'amplitude/amplitude';


export default class Comfort extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedZoneDetails: null
        };
        this.getSelectedZoneDetails = this.getSelectedZoneDetails.bind(this);
    }

    render() {
        let { selectedZoneDetails } = this.state;
        let content = null;

        if (selectedZoneDetails !== null && selectedZoneDetails !== undefined) {

            if (selectedZoneDetails.allowTemperatureAdjustment && selectedZoneDetails.singleMemberId > 0) {
                if ((selectedZoneDetails.hours !== 1 && selectedZoneDetails.isEnabled)) {
                    content = <TemperatureWidget selectedZoneID={selectedZoneDetails.zoneId} />
                }
                else {
                    //Verify 
                    content = <div className={ComfortStyles.fieldrow} ><p className={ComfortStyles.messageText}>Comfort controls are disabled for this space as it is not occupied currently .</p></div>;
                }
            }
            else {
                content = <div className={ComfortStyles.fieldrow} ><p className={ComfortStyles.messageText}>Comfort controls are not available for this space.</p></div>;
                setAmplitudeEvent("Comfort control message", {"Primary Offering": "TS", "Message type": "Code 5" });
            }
        }
        else {
            //initial loading 
            //to do : display spinner set to center
            content = <p className={ComfortStyles.messageText}>Loading Content.</p>;
        }


        return (
            <div>
                <div className={styles.titleSection}>
                    <SubTitle text={"Comfort"} />
                </div>

                <div className={styles.whiteContainer}>
                    <div className={ComfortStyles.fieldrow}>
                        <AfterHoursSpacesDropDown onSelectedZoneDetails={this.getSelectedZoneDetails} FromComfortScreen={true} />
                    </div>
                    <div className={styles.widgetContentArea}>
                        {content}

                    </div>
                </div>
            </div>
        );
    }

    getSelectedZoneDetails(selectedZoneDetail) {  //Selected zone/space details from drop down.
        if (selectedZoneDetail !== null || selectedZoneDetail !== undefined) {
            localStorage.setItem("ZoneID", selectedZoneDetail.zoneId);
            localStorage.setItem("ZoneName", selectedZoneDetail.zoneName);
            //localStorage.setItem("TempValue",selectedZoneDetail.l_SpacePointValue);
            this.setState({ selectedZoneDetails: selectedZoneDetail });
        }
    }

}
